// extracted by mini-css-extract-plugin
export default {"container":"ServiceData_container__Ikagd","block":"ServiceData_block__RPTBJ"};